module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jOShw"))).then(() => module.bundle.root('1iHdE'));